<section>
  <div class="container-fluid py-4 px-4">

    <div class="container-fluid container-card mb-4">
      <h1 class="heading-1">Event & Activites LMAC</h1>

      <div class="row">
        <div class="col-12 col-md-4 col-lg-4">
          <div class="card card-occupancy mb-2 mb-sm-2 mb-md-0 mb-lg-0 h-100">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/occupancy-lease.png"> Total Event & Activity
              </h5>
              <div class="container-fluid container-box-progress mt-3">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                    <span class="date-event">29/09/24 - 05/10/24</span>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <div class="d-flex flex-column align-items-end">
                      <span class="progress-percent-lease">
                        <span class="text-percent-success"> 15</span>
                      </span>
                    </div>


                  </div>
                </div>
              </div>

              <div class="container-fluid mt-3" style="overflow-x: auto;">
                <div class="row">
                  <div class="col-12">
                    <div id="chart">
                      <apx-chart
                        [series]="chartOptions.series"
                        [chart]="chartOptions.chart"
                        [dataLabels]="chartOptions.dataLabels"
                        [plotOptions]="chartOptions.plotOptions"
                        [yaxis]="chartOptions.yaxis"
                        [xaxis]="chartOptions.xaxis"
                        [legend]="chartOptions.legend"
                        [colors]="chartOptions.colors"
                        [grid]="chartOptions.grid">
                      </apx-chart>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div class="col-12 col-md-8 col-lg-8">

          <div class="card card-event h-100">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/event-type.png"> Event Type
              </h5>

              <div class="container-box-event my-2">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-event">Music </h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="total-event">256</h5>
                  </div>
                </div>
              </div>

              <div class="container-box-event my-2">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-event">Sport </h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="total-event">22</h5>
                  </div>
                </div>
              </div>

              <div class="container-box-event my-2">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-event">Religion </h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="total-event">547</h5>
                  </div>
                </div>
              </div>

              <div class="container-box-event my-2">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-event">Conferences </h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="total-event">84</h5>
                  </div>
                </div>
              </div>

              <div class="container-box-event my-2">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-event">Community </h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="total-event">95</h5>
                  </div>
                </div>
              </div>


            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="container-fluid container-card">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6">
          <h1 class="heading-1">Event list</h1>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="form-group group-input">
            <input type="text" class="form-control" placeholder="Search Event & Activity">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
      </div>

      <div class="table-responsive my-3 p-0">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="sortable-header">
                <span>Event Name</span>
                <img src="assets/icons/sort.png" alt="sort" class="sort-icon">
              </th>
              <th class="text-center sortable-header">
                <span>Date</span>
                <img src="assets/icons/sort.png" alt="sort" class="sort-icon">
              </th>
              <th class="text-center sortable-header">
                <span>Attendance</span>
                <img src="assets/icons/sort.png" alt="sort" class="sort-icon">
              </th>
              <th class="text-center sortable-header">
                <span>Event Type</span>
                <img src="assets/icons/sort.png" alt="sort" class="sort-icon">
              </th>
              <th class="sortable-header">
                <span>Revenue</span>
                <img src="assets/icons/sort.png" alt="sort" class="sort-icon">
              </th>
            </tr>
          </thead>
          <!-- <tbody>
            <tr *ngFor="let item of leaseItem">
              <td>{{ item.building }}</td>
              <td class="text-center">{{ item.tenant }}</td>
              <td class="text-center">{{ item.floorUser }}</td>
              <td class="text-center">{{ item.floorAvailable }}</td>
              <td class="text-center">{{ item.sqmAvailable }}</td>
              <td>{{ item.clientType }}</td>
            </tr>

          </tbody> -->
        </table>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-6 total-page-number">

          <h5 class="pageCount">
            Displaying <span class="perPage">1 - 10</span> out of <span class="totalPerPage">2,120</span>
          </h5>
        </div>
        <div class="col-12 col-md-6 col-lg-6 page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link first-page" href="#" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item">
                <a class="page-link prev-page" href="#" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item"><a class="page-link" href="#">1</a></li>
              <li class="page-item active"><a class="page-link" href="#">2</a></li>
              <li class="page-item"><a class="page-link" href="#">3</a></li>
              <li class="page-item">
                <a class="page-link next-page" href="#" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item">
                <a class="page-link last-page" href="#" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

  </div>
</section>
